export const dashboard = {
  title: "Intuïtief overzicht",
  subtitle: "Beheer al uw ruilen vanuit een eenvoudige en moderne interface",
  features: {
    stats: {
      title: "Gedetailleerde statistieken",
      description:
        "Volg uw Nachten, ruilen en gerealiseerde besparingen in real-time",
    },
    notifications: {
      title: "Slimme meldingen",
      description:
        "Ontvang waarschuwingen voor nieuwe aanvragen en belangrijke berichten",
    },
    management: {
      title: "Vereenvoudigd beheer",
      description:
        "Beheer uw beschikbaarheid, reserveringen en ruilen in een paar klikken",
    },
  },
  cta: "Ontdek het overzicht",
  exchangeConfirmed: "Ruil bevestigd",
  newRequests: "nieuwe aanvragen",
  toReview: "Te beoordelen",
};
